import React, { useContext, useEffect, useState } from "react";
import confetti from 'canvas-confetti';

import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  Paper,
  Container,
  Divider,
  Card,
  CardContent,
  makeStyles,
  Stepper,
  Step,
  StepLabel,
  Tabs,
  Tab,
  LinearProgress,
} from "@material-ui/core";
import { useStyles } from "../styles";
import { useHistory } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Logo from "../components/Logo";
import { Store } from "../Store";
import MainFooter from "../components/MainFooter";
import { Alert } from "@material-ui/lab";
import {
  createOrder,
  setPaymentType,
  generateQrCode,
  clearOrder,
  getCheckoutUrl,
  getUserData,
  setCustomerId,
} from "../actions";
import QRCode from "react-qr-code";
import axios from "axios";
import config, { getParameterByName, merchantCode } from "../util";
//import BillPrint from "./BillPrint";
import { useIntl } from "react-intl";
import BillSummary from "../components/Bill_Summary";
import TrackingScreen from './TrackingScreen';
import SafeQRCode from '../components/SafeQRCode'; // Import the safe QRCode component
import useResizeObserverSafe from '../utils/useResizeObserverSafe';
import SafeButton from '../components/SafeButton'; // Import the SafeButton component

import { CheckCircle, AccessTime, RestaurantMenu } from '@material-ui/icons';

export default function CompleteOrderScreen(props) {
  const styles = useStyles();
  const { state, dispatch } = useContext(Store);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const [checkingOrderStatus, setCheckingOrderStatus] = useState(false);  // State to track order status checking
  const history = useHistory();
  const [display, setDisplay] = useState(false);
  const [fontColor, setFontColor] = useState();
  const [detailview, setDetailView] = useState(false);
  const [orderAccepted, setOrderAccepted] = useState(false);
  const [order, setOrder] = useState(null);
  const [tabSel, setTabSel] = useState(1);
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

  useEffect(() => {
    if (orderAccepted && orderAccepted.toUpperCase() === "ACCEPTED") {
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 }
      });
    }
  }, [orderAccepted]);

  useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //let { setting } = state.userSetting;
  let userData = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
  const baseURL = config.baseURL;
  const orderId = getParameterByName('ord_id');
  //const orderId = getParameterByName('ord_id');
  const merchantCode = getParameterByName('merchantCode');
  const handleBack = () => {
    //setDisplayOrder(false);
    return props.history.push("/?" + window.location.href.split("?")[1]);
  };

  const backSpaceImage = () => {
    return (
      <img
        src="/images/backspace-1.png"
        alt="backSpace"
        height="40vh"
        width="40vw"
      />
    );
  };

  useEffect(() => {
    //ord ? order.orderItems : "";

    // axios.patch(`${config.baseURL}/api/temporders/${orderId}?merchantCode=${merchantCode}`, {isPaid:true}).then(() => {
    //   console.log('order paid');
    // });


  }, []);
  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }
  const goto = (subpath) => {
    history.push('/' + subpath + '?merchantCode=' + merchantCode + "&isScan=" + getParameterByName("isScan"));
  }
  // Function to check if order has been accepted
  const checkOrderAcceptance = async () => {
    setCheckingOrderStatus(true);
    try {
      let response = await axios.get(
        `${config.baseURL}/api/temporders/${orderId}/?merchantCode=${merchantCode}`
      );
      console.log(response);
      //setOrder(response.data);
      if (response.data && response.data.orderStatus === "ACCEPTED") {
        setOrderAccepted(response.data.orderStatus);
        setDetailView(true);
        response = await axios.get(
          `${config.baseURL}/api/orders/${response.data.orderId}/?merchantCode=${merchantCode}`);
        setOrder(response.data);
      } else if (response.data && response.data.orderStatus === "REJECTED") {
        setOrderAccepted(response.data.orderStatus);
        setTimeout(() => {
          history.push("/?" + window.location.href.split("?")[1]);
        }, 5000);
      } else {
        setOrderAccepted(false);
      }
    } catch (error) {
      console.error('Error checking order status:', error);
    } finally {
      setCheckingOrderStatus(false);
    }
  };

  useEffect(() => {
    checkOrderAcceptance();
    clearOrder(dispatch); // Reset cart on completion
    window.statusCheckInterval = setInterval(() => {
      checkOrderAcceptance();
    }, 30000);
    return () => {
      if (window.statusCheckInterval) {
        clearInterval(window.statusCheckInterval);
        window.statusCheckInterval = null;
      }
    };
  }, []);

  const OrderStatusIndicator = () => {
    return (
      <Card style={{ margin: "10px" }}>
        <Box>

          <Typography variant="h5" component="div" style={{
            marginTop: 10,
            marginBottom: 10,
            color: userData?.themeTxtColor,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <span style={{ marginRight: 8 }}>✅</span>
            Order Confirmed

          </Typography>
          <h3>{order ? "Token #" + order?.number : ""}</h3>


          <Typography variant="h6" >
            {order && orderAccepted
              ? "Restaurant has accepted your order!"
              : "Waiting for restaurant to accept your order..."
            }
          </Typography>
          {!orderAccepted && (
            <Typography variant="body2" color="textSecondary">
              Confirming your order, Please wait...
            </Typography>
          )}

        </Box>

        {!orderAccepted && (
          <Box >
            <LinearProgress color="secondary" />
          </Box>
        )}
      </Card>
    );
  };


  return (
    <Box className={[styles.root, styles.navy]} style={{ backgroundColor: userData.themeColor, overflow: "hidden", overflowY: "auto" }}>
      <Box
        id="paymentroot"
        style={{
          backgroundColor: userData?.themeColor,
          color: userData?.themeTxtColor,
          width: "100%",
          padding: "10px 0"
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: "0 15px" }}>
          <ArrowBackIosNewIcon
            style={{ color: userData.themeTxtColor, cursor: "pointer" }}
            onClick={() => goto('order')}
          />
          <Typography
            variant="h4"
            component="h1"
            id="title2"
            style={{ fontWeight: 600 }}
          >
            {"Order Status"}
          </Typography>
          <Box style={{ width: "24px" }} /> {/* Spacer to help center the title */}
        </Box>


        <Divider style={{ marginBottom: 16 }} />

        <Box>
          {orderAccepted && orderAccepted?.toUpperCase() == "REJECTED" && <h3 style={{ padding: "5px 20px", color: "red" }}>Order Rejected</h3>}
          {!orderAccepted && <CircularProgress></CircularProgress>}
          {!orderAccepted && <h3 style={{ padding: "5px 20px" }}>{"Please wait, while we confirm your order with Restaurant."}</h3>}

          {orderAccepted && orderAccepted?.toUpperCase() == "ACCEPTED" && <h3 style={{ padding: "5px 20px" }}>{t({ id: "order_placed" })}</h3>}

        </Box>

        {/* Show pickup instructions if this is a pickup order */}
        {orderAccepted && orderAccepted?.toUpperCase() == "ACCEPTED" && order && order.orderType === 'Pick Up' && (
          <Box
            my={3}
            p={3}
            style={{
              border: '2px solid #4CAF50',
              borderRadius: '8px',
              backgroundColor: '#F1F8E9',
              textAlign: 'center'
            }}
          >
            <OrderStatusIndicator />
            <Typography
              variant="h6"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#FFF',
                marginBottom: '8px'
              }}
            >
              <RestaurantMenu style={{ marginRight: '8px' }} />
              Pickup Instructions
            </Typography>
            <Typography>
              Your order is confirmed and will be ready for pickup soon.
            </Typography>
            <Typography style={{ marginTop: '8px', fontWeight: 'bold' }}>
              Please collect your order from the restaurant counter.
            </Typography>
            {order && order.number && (
              <Typography style={{ marginTop: '16px', fontSize: '20px' }}>
                Order #: <span style={{ fontWeight: 'bold', color: '#2E7D32' }}>{order.number}</span>
              </Typography>
            )}
          </Box>
        )}

        {/* Show map/tracking only when order is accepted and not pickup */}
        {detailview && orderAccepted && order && order.orderType !== 'Pick Up' && order.deliveryDetails?.driverAssignments[0]?.status == "PICKED_UP" &&
          <Box
            my={3}
            boxShadow={3}
            borderRadius="borderRadius"
            overflow="hidden"
            style={{
              border: '2px solid #e0e0e0',
              position: 'relative'
            }}
          >
            <TrackingScreen history={props.history} />
          </Box>
        }
      </Box>
      {!isLandscape && (
        <MainFooter tabSel={0} />
      )}
    </Box>
  );
}
